module.exports = __webpack_public_path__ + "img/log.2bbba0f9.png";